'use client';

import React from 'react';
import CartDrawer from '@/components/CartDrawer';
import CheckoutModal from '@/components/CheckoutModal';
import RfqModal from '@/components/RfqModal';
import OrderTrackingModal from '@/components/OrderTrackingModal';
import InvoiceModal from '@/components/InvoiceModal';
import AccountModal from '@/components/AccountModal';
import ContactModal from '@/components/ContactModal';
import { useCommerce } from '@/context/CommerceContext';

export default function GlobalModals() {
  const {
    isTrackingOpen,
    setIsTrackingOpen,
    isInvoiceOpen,
    setIsInvoiceOpen,
    invoiceOrder,
    openInvoice,
  } = useCommerce();

  return (
    <>
      <CartDrawer />
      <CheckoutModal />
      <RfqModal />
      <AccountModal />
      <ContactModal />

      {isTrackingOpen && (
        <OrderTrackingModal
          isOpen={isTrackingOpen}
          onClose={() => setIsTrackingOpen(false)}
          onOpenInvoice={(order) => {
            setIsTrackingOpen(false);
            openInvoice(order);
          }}
        />
      )}

      {isInvoiceOpen && invoiceOrder && (
        <InvoiceModal
          isOpen={isInvoiceOpen}
          order={invoiceOrder}
          onClose={() => setIsInvoiceOpen(false)}
        />
      )}
    </>
  );
}
